import { DISPLAY_TYPES, type CompiledSchema, type FormField } from '@re/form-engine';
import { getUiLanguage } from './i18n';

export interface FormStep {
  id: string;
  title: string;
  keys: string[];
}

export const stepTitle = (l?: { ar?: string; en?: string } | null): string => (getUiLanguage() === 'en' && l?.en?.trim() ? l.en : l?.ar ?? '').trim();

/**
 * Steps follow `field.section` — the same rule as the public form (FormTagsWebsite/client/src/steps.ts).
 * Small forms (≤ 6 inputs or a single section) stay on one page.
 */
export function buildSteps(schema: CompiledSchema): FormStep[] {
  const fields = [...schema.fields].sort((a, b) => a.order - b.order);
  const steps: FormStep[] = [];
  let current: FormStep | null = null;
  for (const f of fields) {
    const sid = f.section?.trim();
    if (sid) {
      current = steps.find((s) => s.id === sid) ?? null;
      if (!current) {
        current = { id: sid, title: '', keys: [] };
        steps.push(current);
      }
    }
    if (!current) {
      current = { id: '_first', title: '', keys: [] };
      steps.push(current);
    }
    current.keys.push(f.key);
    if (f.type === 'section' && !current.title) current.title = stepTitle(f.label);
  }
  const byKey = new Map<string, FormField>(fields.map((f) => [f.key, f]));
  for (const s of steps) {
    if (!s.title) s.title = stepTitle(s.keys.map((k) => byKey.get(k)).find((f) => f?.type === 'section')?.label);
  }
  const inputs = fields.filter((f) => !DISPLAY_TYPES.has(f.type)).length;
  if (steps.length < 2 || inputs <= 6) return [{ id: 'all', title: '', keys: fields.map((f) => f.key) }];
  return steps;
}
